module.exports = __webpack_public_path__ + "static/img/Salang_logo.c13a1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Salang_logo.png
// module id = I5SP
// module chunks = 0